// Cross-route thread selection hand-off (sidebar portal → /threads page).
//
// The routes render inside <AnimatePresence mode="wait">, so after
// navigate("/threads") the page only mounts once the OLD route's exit
// animation finishes — any event dispatched before that has no listener and
// is lost (the old timeout-after-currentAppPage-flips approach raced exactly
// this and lost, which is why selecting a thread from another route took two
// clicks). Pull model instead: the portal stashes the selection here before
// navigating, and the page consumes it in its mount effect — whenever that
// mount actually happens.
//
// `undefined` = nothing pending; `null` is a real selection (a draft).
let pending = undefined;

export const setPendingThreadSelect = (threadId) => {
  pending = threadId;
};

export const takePendingThreadSelect = () => {
  const value = pending;
  pending = undefined;
  return value;
};
